import { render, staticRenderFns } from "./Integracao-rnds-logs.vue?vue&type=template&id=1c701c2b&"
import script from "./Integracao-rnds-logs.vue?vue&type=script&lang=js&"
export * from "./Integracao-rnds-logs.vue?vue&type=script&lang=js&"
import style0 from "./Integracao-rnds-logs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports